import React, { useState } from 'react';
import { openFeedbackPrompt } from '../utils/platformFeedback';
import PlatformExperienceSummary from './PlatformExperienceSummary';
import './FooterExperienceRating.css';

const FooterExperienceRating = () => {
  const [hover, setHover] = useState(0);

  const handleStarClick = (score) => {
    openFeedbackPrompt('footer', score);
  };

  return (
    <div className="footer-quick-rate-box">
      <button
        type="button"
        className="footer-quick-rate-label footer-quick-rate-label-btn"
        onClick={() => openFeedbackPrompt('footer')}
      >
        Rate Our Website
      </button>
      <div
        className="footer-quick-rate-stars"
        role="group"
        aria-label="Rate our website from 1 to 5 stars"
      >
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            className={`footer-quick-rate-star${hover >= n ? ' active' : ''}`}
            onMouseEnter={() => setHover(n)}
            onMouseLeave={() => setHover(0)}
            onClick={() => handleStarClick(n)}
            aria-label={`Rate ${n} star${n > 1 ? 's' : ''}`}
          >
            ★
          </button>
        ))}
      </div>
      <PlatformExperienceSummary className="footer-quick-rate-summary" />
    </div>
  );
};

export default FooterExperienceRating;
